module.exports = "data:image/png;base64,UklGRngAAABXRUJQVlA4TGsAAAAvDcAEEHUwbttGUv9V8xPM2YBnZheIYFNbe5MtRU6bIyQnEgpo4KACBUyYaBZ6rwKYOhOQba1+E9xCC3+8JZD7b1QnihZZImrhJfwWIiEbHECC/HZtKecmAZ1UmgW+v9QVveJXvFdJqlMsCwA="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workspace/cart.png
// module id = nuXT
// module chunks = 1